import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth/AuthProvider';
import { homePathFor } from '../lib/home';
import { FullPageSpinner } from './ui';

/**
 * Guarda de rutas privadas. Mientras se bootea la sesión muestra un spinner;
 * si no hay sesión redirige a /login guardando el destino en `state.from`.
 */
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullPageSpinner />;
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}

/**
 * Para /login y /registro: si ya hay sesión, manda a la home (o al destino
 * original que quedó guardado antes del redirect a login).
 */
export function PublicOnlyRoute() {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullPageSpinner />;
  if (status === 'authenticated') {
    // Destino previo (deep link) o la página de inicio preferida del usuario.
    const from = (location.state as { from?: string } | null)?.from ?? homePathFor(user);
    return <Navigate to={from} replace />;
  }
  return <Outlet />;
}
